import { render, staticRenderFns } from "./PPagination.vue?vue&type=template&id=2b4cc466&"
import script from "./PPagination.vue?vue&type=script&lang=js&"
export * from "./PPagination.vue?vue&type=script&lang=js&"
import style0 from "./PPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports